module.exports = __webpack_public_path__ + "img/chevron.490fda33.svg";